import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { UserSelectorService } from './user-selector.service';
import { Subscription } from 'rxjs';
import { User } from '@ee/common/models';

@Component({
  selector: 'ee-user-selector',
  template: `
    <ng-select
      [items]="userSuggestions"
      [multiple]="true"
      [closeOnSelect]="false"
      bindLabel="display_name"
      bindValue="id"
      [appendTo]="appendTo"
      [fixedPlaceholder]="true"
      [appearance]="appearance"
      [placeholder]="placeholder"
      [formControl]="$any(selectedUsers)">
      <ng-template ng-multi-label-tmp let-users="items" let-clear="clear">
        @for (user of users; track user) {
          @if (excludeUserIds.includes(user.id)) { continue; }
          <div class="ng-value">
            <span class="small" [tp]="user.display_name" tpPlacement="top" [tpDelay]="500"
                  [attr.data-letters]="user.display_name | dataLetters" [ngStyle]="{'--user-selector-color': user.color}"></span>
          </div>
        }
      </ng-template>
      <ng-template ng-option-tmp let-user="item">
        <span class="small mr-2" [attr.data-letters]="user.display_name | dataLetters"
              [ngStyle]="{'--user-selector-color': user.color}"></span> {{ user.display_name }}
      </ng-template>
    </ng-select>
  `,
  styles: [
    `
      .ng-value {
        background-color: transparent !important;
        margin: 0 !important;
      }
    `
  ],
  standalone: false
})
export class UserSelectorComponent implements OnInit, OnDestroy {
  @Input({ required: true })
  public selectedUsers: FormControl;
  @Input({ required: false })
  public placeholder: string = 'Assign users...';
  /**
   * CSS selector the ng-select dropdown panel is appended to. Defaults to `body` (so the panel
   * escapes scroll/overflow containers). Inside a Material dialog, `body` renders the panel behind the
   * dialog (CDK overlay pane is z-index 1000) — pass `null` there to render the panel inline within
   * the ng-select so it stays pinned inside the modal and directly under the input.
   */
  @Input({ required: false })
  public appendTo: string | null = 'body';
  @Input({ required: false })
  public appearance: 'fill' | 'outline' = 'outline';
  @Input({ required: false })
  public excludeUserIds: number[] = [];
  @Input({ required: false })
  public userSuggestions: User[] = [];

  private subs: Subscription[] = [];

  constructor(private userSelectorService: UserSelectorService) {}

  ngOnDestroy() {
    this.subs.forEach(s => s.unsubscribe());
  }

  ngOnInit() {
    if (!this.userSuggestions) {
      this.subs.push(this.userSelectorService.getUserSuggestions().subscribe(users => (this.userSuggestions = users)));
    }
  }
}
